module.exports = __webpack_public_path__ + "img/bg.55fa67a0.jpg";